import { css } from '@emotion/react'
import { memo, useCallback } from 'react'
import { streamClubShow } from '../../../../../actions/room'
import { openShareThingDrawer } from '../../../../../app-state/modals/state.drawer'
import Button from '../../../../Buttons/Button'
import { useUserSelector } from '../../../../Hooks/useUser'
import APP_BREAKPOINTS, { maxRoomWidth } from '../../../../styles/breakpoints'
import { palette } from '../../../../styles/colors'

const ClubShowRow = memo((props) => {
    const { name, slug, amt } = props as any

    const onClubShowClick = useCallback(
        (e) => {
            e.stopPropagation()
            e.preventDefault()
            openShareThingDrawer({
                name, // club show name
                thing: slug, // the club show identifier
                thing_type: 'clubs',
            })
        },
        [name, slug],
    )
    return (
        <li>
            <a
                onClick={onClubShowClick}
                href={`https://share.myfreecams.com/m/${slug}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    color: 'rgb(2, 136, 209)',
                    fontWeight: 'bold',
                }}
            >
                {name}
            </a>
            {` ( ${amt} token${amt !== 1 ? 's' : ''} )`}
        </li>
    )
})

const clubShowRootStyles = css({
    fontFamily: 'Montserrat, Helvetica, Arial, Sans-Serif !important',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 500,
    display: 'flex',
    padding: 12,
    width: '100%',
    [maxRoomWidth(APP_BREAKPOINTS.sm)]: {
        padding: 4,
    },
    '& .alert-message': {
        width: '100%',
    },
})
const clubShowNameStyles = css({
    fontSize: 16,
    [maxRoomWidth(APP_BREAKPOINTS.sm)]: {
        fontSize: 14,
    },
})
const clubsContainerStyles = css({
    borderBottom: `1px solid ${palette.drawerDivider}`,
    fontSize: 12,
    marginBottom: 16,
    padding: 16,
    [maxRoomWidth(APP_BREAKPOINTS.sm)]: {
        marginBottom: 8,
        padding: 8,
    },
})
const clubListStyles = css({
    listStyleType: 'none',
    textAlign: 'center',
    padding: 0,
    fontSize: 12,
    margin: 8,
    [maxRoomWidth(APP_BREAKPOINTS.sm)]: {
        fontSize: 10,
        margin: 4,
    },
})
const inClubStyles = css({
    marginBottom: 8,
    fontSize: 16,
    [maxRoomWidth(APP_BREAKPOINTS.sm)]: {
        marginBottom: 4,
        fontSize: 14,
    },
})

type PMChatMessageClubShowProps = {
    id: number
}

const PMChatMessageClubShow = memo((props: PMChatMessageClubShowProps) => {
    const { id } = props
    const name = useUserSelector(id, 'name')
    const tksid = useUserSelector(id, 'clubShow', {}, true, 'tksid')
    const clubs = useUserSelector(id, 'clubShow', {}, true, 'clubs') || []
    const enabledMultipleClubs = clubs?.length > 1

    const onClickClubShowMessage = useCallback(() => {
        streamClubShow(id)
    }, [id])

    return (
        <div css={clubShowRootStyles}>
            <div css={clubShowNameStyles}>{name} is in a Club Show</div>
            <div css={clubsContainerStyles}>
                <div>
                    The following club{enabledMultipleClubs ? 's ' : ' '}
                    ha{enabledMultipleClubs ? 've' : 's'} access:
                </div>
                <ul css={clubListStyles}>
                    {clubs.map((club, key) => (
                        <ClubShowRow {...club} key={key} />
                    ))}
                </ul>
            </div>
            {!tksid && (
                <div>
                    Join {enabledMultipleClubs ? 'one of ' : ''}the club
                    {enabledMultipleClubs ? 's' : ''} for instant access!
                </div>
            )}
            {tksid && (
                <>
                    <div css={inClubStyles}>{`You're in the club!`}</div>
                    <Button
                        data-testid="Link__EnterClubShow"
                        onClick={onClickClubShowMessage}
                        size="medium"
                    >
                        Enter the Show
                    </Button>
                </>
            )}
        </div>
    )
})

export default PMChatMessageClubShow
